module.exports = __webpack_public_path__ + "static/media/bg_template_1.68da1509.jpg";